module.exports = __webpack_public_path__ + "img/11069848_L.3f7b3e61.png";